import React, { Component } from "react";
import { connect } from "react-redux";
import { getCall, postCall } from "../../../../api/post";
import {
  getCommonCounter,
  getUpdateQuantity,
  getWishlist,
  isInquiryOrCart,
  addToCompare,
  setHeaderCounters,
} from "../../../../actions";
import { Chip } from "@react-md/chip";
import {
  getValueFromLanguageObject,
  getCurrencySymbol,
  loadUserDetailsFromLocalStorage,
  getOpenStoreIdApp,
  formatPrice,
} from "../../../../store";
import {
  getImageUrl,
  getPlaceHolderImage,
  getSettingUrl,
  getPincodeDeliveryUrl,
  getMasterDetailsIdUrl,
  getShringOptionSettingsUrl,
  getTenantInfoUrl,
  getAddToWishlistUrl,
} from "../../../../services";
import {
  FacebookShareButton,
  FacebookIcon,
  TelegramShareButton,
  TelegramIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ErrorMessageAnimationModal from "../../../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../../../animation/SuccessMessageAnimationModal";
import AddToCartAnim from "../../../../animation/AddToCartAnim";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../../utils/utils";
import { withRouter } from "react-router-dom";
import Moment from "react-moment";
import AddToWishListAnim from "../../../../animation/AddToWishListAnim";
import {
  checkAuthAndRedirect,
  getCurrentPath,
} from "../../../../utils/cartRedirect";

const productDesc = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  "-webkitLineClamp": "4",
  "-webkitBoxOrient": "vertical",
};
const publicUrl = window.location.pathname.split("/")[1];
const client = process.env.CLIENT_NAME;
class DetailsWithPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity:
        props.item.minimumorderquantity >= 1
          ? props.item.minimumorderquantity
          : 1,
      stock:
        props.item.availablequantity <= 0
          ? getValueFromLanguageObject("str_out_of_stock")
            ? getValueFromLanguageObject("str_out_of_stock")
            : "Out of Stock!"
          : getValueFromLanguageObject("InStock")
          ? getValueFromLanguageObject("InStock")
          : "InStock",
      nav3: null,
      category: {},
      shareUrl: "",
      sharingOptionSettings: null,
      productPrice: props.item.price,
      product: props.item,
      selectedVariation: [],
      pincode: "",
      isSubmitDisable: true,
      currentCatelogueType: {},
      isPincodeDeliveryEnable: false,
      isLoading: true,
      showErrorMessageModal: false,
      errorMessage: "",
      showSuccessMessageModal: false,
      successMessage: "",
      showAddToCartMessageModal: false,
      addToCartMessage: "",
      showAddToWishListMessageModal: false,
      addToWishListMessage: "",
      showAddToCompareMessageModal: false,
      addToCompareMessage: "",
      masterDetailsObj: {},
      isShowLastModifiedDate: false,
    };
  }

  componentDidMount() {
    this.setState({
      nav3: this.slider3,
    });

    this.initMasterDetailsId().then(() => {
      const { masterDetailsObj } = this.state;
      this.initTenantInfo();
      this.initSingleCategory();
      this.initCatelogueSettings();
      this.initPincodeDelivery();
      this.props.isInquiryOrCart(masterDetailsObj);
      const userDetails = loadUserDetailsFromLocalStorage();
      const { id } = userDetails || {};
      if (id) {
        this.props.getWishlist(id);
      }
      this.initShareLink();
      this.initSharingOption();
    });
  }

  // Decode HTML entities so stored/escaped HTML renders correctly
  decodeHtmlEntities = (html) => {
    if (!html || typeof html !== "string") return html;
    try {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    } catch (e) {
      return html;
    }
  };

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initSingleCategory = async () => {
    const { item } = this.props;
    if (!item || !item.category || item.category.parentId == null) {
      return;
    }

    const singleCategoryUrl = "categories/" + this.props.item.category.parentId;
    const singleCategory = await getCall(singleCategoryUrl, []);
    if (singleCategory.error) {
      clearLocalStorageReload({ response: singleCategory });
      this.loadErrorMessageAnimation(singleCategory.error.message);
      if (singleCategory.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ category: singleCategory });
    }
  };

  initPincodeDelivery = async () => {
    const { masterDetailsObj } = this.state;
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    const pincodeDelivery = await getCall(
      getPincodeDeliveryUrl(masterDetailsObj),
      []
    );
    if (pincodeDelivery.error) {
      clearLocalStorageReload({ response: pincodeDelivery });
      this.loadErrorMessageAnimation(pincodeDelivery.error.message);
      // this.setState({productPrice: this.state.productPrice,selectedVariation: this.state.selectedVariation})
    } else {
      if (pincodeDelivery.length > 0) {
        const status = pincodeDelivery[0].status;
        this.setState({ isPincodeDeliveryEnable: status === 1 ? true : false });
      }
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      if (settings.registerallow === "Catalogue_FABRIC") {
        this.initProductVariationQuantity(this.props.item);
      }
      this.setState({ currentCatelogueType: settings });
    }
  };

  initShareLink = async () => {
    const shareLinkUrl = "products/shortnewURL";
    const link = window.location.href.replace("singleproduct", "p");
    const shareLinkObj = {
      url: link,
    };
    const shareLinkResponse = await postCall(shareLinkUrl, shareLinkObj);
    if (shareLinkResponse.error) {
      clearLocalStorageReload({ response: shareLinkResponse });
      this.loadErrorMessageAnimation(shareLinkResponse.error.message);
    } else {
      this.setState({ shareUrl: shareLinkResponse.shortUrl });
    }
  };

  initSharingOption = async () => {
    const { masterDetailsObj } = this.state;
    const shringOptionSettingsUrl = getShringOptionSettingsUrl(
      masterDetailsObj
    );
    const shringOptionSettingsResponse = await getCall(shringOptionSettingsUrl);
    if (shringOptionSettingsResponse.error) {
      clearLocalStorageReload({ response: shringOptionSettingsResponse });
      this.loadErrorMessageAnimation(
        shringOptionSettingsResponse.error.message
      );
    } else {
      if (
        shringOptionSettingsResponse &&
        shringOptionSettingsResponse.length > 0
      ) {
        this.setState({
          sharingOptionSettings: shringOptionSettingsResponse[0],
        });
      } else {
        this.setState({ sharingOptionSettings: null });
      }
    }
  };

  initTenantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const { id } = masterDetailsObj || {};
    if (!id) {
      return;
    }
    const tenantInfoUrl = getTenantInfoUrl(id);
    const tenantInfo = await getCall(tenantInfoUrl, []);
    if (tenantInfo.error) {
      clearLocalStorageReload({ response: tenantInfo });
      this.loadErrorMessageAnimation(tenantInfo.error.message);
    } else {
      const [tenantConfig] = tenantInfo || [];
      const { text } = tenantConfig || {};
      let config = JSON.parse(text);
      const { isShowLastModifiedDate } = config || {};
      this.setState({ isShowLastModifiedDate });
    }
  };

  initProductVariationQuantity = (item) => {
    let tempItem = item;
    let variationArrayTemp = [];
    if (tempItem.productvariation) {
      let variation = JSON.parse(tempItem.productvariation);
      for (let index = 0; index < variation.length; index++) {
        if (variation[index].quantity === null) {
          variation[index].quantity = 1;
          variationArrayTemp.push(variation[index]);
        }
      }
    }
    tempItem.productvariation = JSON.stringify(variationArrayTemp);
    this.setState({ product: tempItem });
  };

  minusQty = () => {
    const minimumorderquantity = this.props.item.minimumorderquantity
      ? this.props.item.minimumorderquantity
      : 1;
    if (this.state.quantity > minimumorderquantity) {
      this.setState({
        stock: getValueFromLanguageObject("str_instock")
          ? getValueFromLanguageObject("str_instock")
          : "InStock",
      });
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  plusQty = () => {
    if (this.props.item.availablequantity > this.state.quantity) {
      this.setState({ quantity: this.state.quantity + 1 });
    } else {
      this.setState({
        stock: getValueFromLanguageObject("str_out_of_stock")
          ? getValueFromLanguageObject("str_out_of_stock")
          : "Out of Stock!",
      });
    }
  };

  changeQty = (e) => {
    const { item } = this.props;
    const value = parseInt(e.target.value);

    if (isNaN(value) || value < 1) return;

    // Only show out of stock if value is greater than availablequantity
    if (value > item.availablequantity) {
      this.setState({
        quantity: item.availablequantity,
        stock: getValueFromLanguageObject("str_out_of_stock") ||
          "Out of Stock!",
      });
      return;
    }

    this.setState({
      quantity: value,
      stock: getValueFromLanguageObject("str_instock") || "InStock",
    });
  };

  setSelectedSize = (price) => {
    this.setState({ productPrice: price });
  };

  renderVariationText = (vari) => {
    let text = "";
    if (vari && vari.variation && vari.variation.length > 0) {
      text = vari.variation.map((variation) => {
        return variation.value;
      });
    }
    return text.join(" - ");
  };

  renderVariationQuantity = (vari) => {
    return vari.quantity;
  };

  decreaseProductVariation = (vari, index) => {
    if (vari.quantity === 0) {
      return;
    }
    const { product } = this.state;
    let tempItem = product;
    let variationArrayTemp = [];
    if (tempItem.productvariation) {
      let variation = JSON.parse(tempItem.productvariation);
      for (let i = 0; i < variation.length; i++) {
        if (i === index) {
          variation[i].quantity = variation[i].quantity - 1;
        }
        variationArrayTemp.push(variation[i]);
      }
    }
    tempItem.productvariation = JSON.stringify(variationArrayTemp);
    this.setState({ product: tempItem });
  };

  increaseProductVariation = (vari, index) => {
    const { product } = this.state;
    if (product.availablequantity <= vari.quantity) {
      return;
    }
    let tempItem = product;
    let variationArrayTemp = [];
    if (tempItem.productvariation) {
      let variation = JSON.parse(tempItem.productvariation);
      for (let i = 0; i < variation.length; i++) {
        if (i === index) {
          variation[i].quantity = variation[i].quantity + 1;
        }
        variationArrayTemp.push(variation[i]);
      }
    }
    tempItem.productvariation = JSON.stringify(variationArrayTemp);
    this.setState({ product: tempItem });
  };

  renderPriceVarientPanam = (productvariation) => {
    const { masterDetailsObj } = this.state;
    const { symbol } = this.props;
    const priceVarient = JSON.parse(productvariation);
    return (
      priceVarient && (
        <ul>
          {priceVarient.map((vari, i) => {
            return (
              <div>
                <img
                  style={{ height: "50px", width: "50px" }}
                  src={
                    vari.image && vari.image.length > 0 && vari.image[0].name
                      ? getImageUrl(vari.image[0].name, masterDetailsObj)
                      : getPlaceHolderImage()
                  }
                  alt=""
                />
                {this.renderVariationText(vari)}
                <h3>{formatPrice(vari.price)}</h3>
                <div className="qty-box">
                  <div className="input-group">
                    <span className="input-group-prepend">
                      <button
                        type="button"
                        className="btn quantity-left-minus"
                        onClick={() => this.decreaseProductVariation(vari, i)}
                        data-type="minus"
                        data-field=""
                      >
                        <i className="fa fa-angle-left" />
                      </button>
                    </span>
                    <div className="form-control input-number">
                      {this.renderVariationQuantity(vari)}
                    </div>

                    <span className="input-group-prepend">
                      <button
                        type="button"
                        className="btn quantity-right-plus"
                        onClick={() => this.increaseProductVariation(vari, i)}
                        data-type="plus"
                        data-field=""
                      >
                        <i className="fa fa-angle-right" />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </ul>
      )
    );
  };

  addActiveClass = (subitem, i) => {
    const { selectedVariation } = this.state;
    const activeVariation = selectedVariation.filter((variation) => {
      const { value } = variation;
      const { value: subItemValue } = subitem;
      if (value === subItemValue) {
        return variation;
      } else {
        return "";
      }
    });

    if (activeVariation.length > 0) {
      return "active";
    } else {
      return "";
    }
  };

  renderPriceVarientKey = (productvariation) => {
    const priceVarient = JSON.parse(productvariation);

    let tempKey = [];
    priceVarient.forEach((element) => {
      element.variation.forEach((vari, i) => {
        tempKey[vari.key] = new Array();
      });
    });

    priceVarient.forEach((element) => {
      element.variation.forEach((vari, i) => {
        if (Object.keys(tempKey)[i] === vari.key) {
          if (JSON.stringify(tempKey[vari.key][i]) !== JSON.stringify(vari)) {
            tempKey[vari.key].push(vari);
          }
        }
      });
    });

    var uniq = {};

    return (
      <div>
        {Object.keys(tempKey).map((item, index) => {
          return (
            <div key={index} className="border-product">
              <h6 className="product-title size-text">{item} : </h6>
              {tempKey[item]
                .filter((obj) => !uniq[obj.value] && (uniq[obj.value] = true))
                .map((subitem, position) => {
                  return (
                    <div className="size-box">
                      <div>
                        {/* <span> */}
                        <li
                          onClick={() => {
                            this.onClickOfVariationValue(
                              priceVarient,
                              item,
                              subitem.value
                            );
                          }}
                          className={`${this.addActiveClass(
                            subitem,
                            position
                          )}`}
                        >
                          {position === 0 &&
                            this.defaultSelectVariation(
                              priceVarient,
                              item,
                              subitem.value,
                              Object.keys(tempKey).length
                            )}
                          {subitem.value}
                        </li>
                        {/* </span> */}
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        })}
      </div>
    );
  };

  onClickOfVariationValue = (priceVarient, keyy, valuee) => {
    let { selectedVariation } = this.state;
    let obj = { key: keyy, value: valuee };
    const i = selectedVariation.findIndex((_item) => _item.key === obj.key);
    if (i > -1) selectedVariation[i] = obj;
    else selectedVariation.push(obj);

    this.setState({ selectedVariation });

    priceVarient.forEach((variation) => {
      if (
        JSON.stringify(variation.variation) ===
        JSON.stringify(selectedVariation)
      ) {
        this.setState({ productPrice: variation.price });
      }
    });
  };

  fetchHeaderCounters = async () => {
    try {
      const response = await getCall("v2/dashboard/header-counters", []);
      if (response.error) {
        return;
      }
      this.props.setHeaderCounters(response); // <-- dispatch to Redux
    } catch (e) {}
  };

  defaultSelectVariation = (priceVarient, keyy, valuee, variationLength) => {
    let { selectedVariation } = this.state;

    if (variationLength === selectedVariation.length) {
      return;
    }
    let obj = { key: keyy, value: valuee };
    selectedVariation.push(obj);
    this.setState({ selectedVariation });
    priceVarient.forEach((variation) => {
      if (
        JSON.stringify(variation.variation) ===
        JSON.stringify(selectedVariation)
      ) {
        this.setState({ productPrice: variation.price });
      }
    });
  };

  renderPriceVarientValue = (productvariation) => {
    const { productPrice } = this.state;
    const priceVarient = JSON.parse(productvariation);
    return (
      priceVarient &&
      priceVarient.length > 0 && (
        <ul>
          {priceVarient.map((pc, i) => {
            return pc.variation.map((vari) => {
              return (
                <Chip
                  key={vari.value}
                  className={"chip-cls"}
                  selected={productPrice === pc.price}
                  selectedThemed
                  onClick={() => this.setSelectedSize(pc.price)}
                >
                  {vari.value}
                </Chip>
              );
            });
          })}
        </ul>
      )
    );
  };

  renderBundlePrice = (productvariation) => {
    let bundlePrice = 0;
    const variation = JSON.parse(productvariation);
    if (variation && variation.length > 0) {
      for (let index = 0; index < variation.length; index++) {
        const element = variation[index];
        if (element.price && element.quantity) {
          bundlePrice = bundlePrice + element.price * element.quantity;
        }
      }
    }
    return bundlePrice;
  };

  onClickOfSampleReuest = async (item) => {
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id, cityId } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;

    const sampleRequestUrl = "orders/productInquiry";
    const sampleRequestObj = {
      orderstatus: 1,
      totalamount: item.price,
      inshoppingcart: 4,
      userId: userId,
      cityId: cityId,
      orderdetails: [
        {
          productId: item.id,
        },
      ],
      date: new Date(),
    };
    const sampleRequest = await postCall(sampleRequestUrl, sampleRequestObj);
    if (sampleRequest.error) {
      clearLocalStorageReload({ response: sampleRequest });
      this.loadErrorMessageAnimation(sampleRequest.error.message);
    } else {
      this.loadSuccessMessageAnimation(
        getValueFromLanguageObject(
          "str_your_sample_request_is_placed_successfully"
        )
      );
    }
  };

  getProductQuote = (item) => {
    const { symbol } = this.props;
    const { shareUrl } = this.state;
    const { name = "", price = "" } = item || {};
    const priceProduct = price ? price.toFixed(2) : 0;
    return `Property Name : ${name} \n Price : ${formatPrice(
      priceProduct
    )} \n ${shareUrl}`;
  };

  getProductQuoteTwitter = (item) => {
    const { symbol } = this.props;
    const { name = "", price = "" } = item || {};
    const priceProduct = price ? price.toFixed(2) : 0;
    return `Property Name : ${name} \n Price : ${formatPrice(priceProduct)}`;
  };

  pincodeHandleSubmit = (event) => {
    // event.preventDefault();
    this.setState({ pincode: event.target.value });
  };

  addToCartBase = () => {
    const { productPrice, product, selectedVariation } = this.state;
    const { item, isInquiry } = this.props;
    // this.setState({ selectedVariation});
    if (process.env.CLIENT_NAME === "panam") {
      this.addToCartClicked(
        product,
        this.state.quantity,
        isInquiry,
        productPrice,
        selectedVariation
      );
    } else {
      this.addToCartClicked(
        item,
        this.state.quantity,
        isInquiry,
        productPrice,
        selectedVariation
      );
    }
  };

  onAddToWishlistClicked = async () => {
    try {
      const { product } = this.state;
      this.setState({ isLoading: true });

      const userDetails = loadUserDetailsFromLocalStorage();
      const { id: productId } = product || {};
      const addtowishlistObj = { productId };
      const addToWishlistUrl = "v2/wishlists";
      const response = await postCall(addToWishlistUrl, addtowishlistObj);

      this.setState({ isLoading: false });

      if (response && response.success) {
        const successMessage =
          getValueFromLanguageObject("str_add_to_wishlist_successfully") ||
          response.message ||
          "Product added to wishlist successfully";
        this.loadAddToWishListMessageAnimation(successMessage);
        await this.fetchHeaderCounters();
      } else if (
        response.detail &&
        response.detail.responseMessageCode === "WISHLIST_DUPLICATE"
      ) {
        this.loadAddToWishListMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_wishlist") ||
          (response.detail.responseData && response.detail.responseData.message) ||
          "Product already in wishlist."
        );
      } else if (
        response.responseData &&
        response.responseData.messageCode === "WISHLIST_DUPLICATE"
      ) {
        this.loadAddToWishListMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_wishlist") ||
          response.responseData.message ||
          "Product already in wishlist."
        );
      } else {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_error_adding_to_wishlist") ||
          response.message ||
          "Failed to add to wishlist."
        );
      }
    } catch (error) {
      this.setState({ isLoading: false });
      if (
        error &&
        (error.responseMessageCode === "WISHLIST_DUPLICATE" ||
          (error.responseData && error.responseData.messageCode === "WISHLIST_DUPLICATE"))
      ) {
        this.loadAddToWishListMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_wishlist") ||
          (error.responseData && error.responseData.message) ||
          "Product already in wishlist."
        );
      } else {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_error_adding_to_wishlist") ||
          "An error occurred while adding to wishlist."
        );
      }
    }
  };

  onAddToCompareClicked = async () => {
    const { product } = this.state;
    this.setState({ isLoading: true });

    const body = { productId: product.id };

    try {
      const response = await postCall("v2/product-comparisons", body);

      if (response && response.success) {
        const successMessage =
          getValueFromLanguageObject("str_add_to_compare_successfully") ||
          response.message ||
          "Product added to compare successfully";
        this.loadSuccessMessageAnimation(successMessage);
        await this.fetchHeaderCounters();
      } else if (
        response.detail &&
        response.detail.responseMessageCode === "COMPARISON_DUPLICATE"
      ) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_comparison") ||
          (response.detail.responseData && response.detail.responseData.message) ||
          "Product already in comparison list."
        );
      } else if (
        response.responseData &&
        response.responseData.messageCode === "COMPARISON_DUPLICATE"
      ) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_comparison") ||
          response.responseData.message ||
          "Product already in comparison list."
        );
      } else if (
        response.responseData &&
        response.responseData.messageCode === "COMPARISON_LIMIT_REACHED"
      ) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_comparison_limit_reached") ||
          (response.responseData && response.responseData.message) ||
          "Comparison list limit reached."
        );
      } else {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_error_adding_to_compare") ||
          response.message ||
          "Failed to add product to comparison."
        );
      }
    } catch (error) {
      if (
        error &&
        (error.responseMessageCode === "COMPARISON_DUPLICATE" ||
          (error.responseData && error.responseData.messageCode === "COMPARISON_DUPLICATE"))
      ) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_comparison") ||
          (error.responseData && error.responseData.message) ||
          "Product already in comparison list."
        );
      } else if (
        error &&
        (error.responseMessageCode === "COMPARISON_LIMIT_REACHED" ||
          (error.responseData && error.responseData.messageCode === "COMPARISON_LIMIT_REACHED"))
      ) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_comparison_limit_reached") ||
          (error.responseData && error.responseData.message) ||
          "Comparison list limit reached."
        );
      } else {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_error_adding_to_compare") ||
          "An error occurred while adding the product to comparison."
        );
      }
    }
  };

  addToCartClicked = (
    item,
    quantity,
    isInquiry,
    productPrice,
    selectedVariation,
    pincode
  ) => {
    const { afterAddToCartClicked } = this.props;
    this.setState({ isLoading: true }, () => {
      this.addToCart(
        item,
        quantity,
        isInquiry,
        productPrice,
        selectedVariation,
        pincode
      ).then((res) => {
        if (
          res &&
          res.message &&
          (
            res.message === "Sorry! Product is out of stock" ||
            res.message === "Sorry! Product is not availble as per given quantity"
          )
        ) {
          // Show as error modal
          this.loadErrorMessageAnimation(
            getValueFromLanguageObject("str_product_out_of_stock") ||
            res.message ||
            "Sorry! Product is out of stock"
          );
          afterAddToCartClicked(res.message, true);
        } else if (res && !res.error) {
          this.loadAddToCartMessageAnimation(
            res.message || "Product added to cart successfully."
          );
          afterAddToCartClicked(
            res.message || "Product added to cart successfully.",
            false
          );
        } else if (res && res.message) {
          this.loadErrorMessageAnimation(res.message);
          afterAddToCartClicked(res.message, true);
        } else {
          this.loadErrorMessageAnimation("Failed to add to cart.");
          afterAddToCartClicked("Failed to add to cart.", true);
        }

        setTimeout(async () => {
          await this.props.counter();
          await this.props.updateQuantity();
          await this.fetchHeaderCounters();
        }, 500);
      });
    });
  };

  addToCart = async (
    product,
    qty,
    isInquiry,
    productPrice,
    selectedVariation,
    pincode
  ) => {
    try {
      // Check authentication first
      const currentPath = getCurrentPath(this.props);
      if (!checkAuthAndRedirect(this.props, currentPath)) {
        return; // User was redirected to login
      }

      let userDetails = loadUserDetailsFromLocalStorage();
      if (!isOpenStoreIdExist() && userDetails === undefined) {
        return;
      } else {
        userDetails = userDetails === undefined ? {} : userDetails;
      }
      const { id, cityId } = userDetails;
      const openStoreId = getOpenStoreIdApp();
      let userId = openStoreId ? openStoreId : id;

      const addtocartUrl = isInquiry
        ? "orders/productInquiry"
        : "orders/addtocart";

      let orderdetailsObj = [];

      if (
        product.productvariation &&
        product.productvariation !== null &&
        product.productvariation !== "[]" &&
        !product.bundlepurchase
      ) {
        const productVariationParse = JSON.parse(product.productvariation);
        if (
          productVariationParse &&
          productVariationParse.length > 0 &&
          !product.bundlepurchase
        ) {
          productVariationParse.map((variation) => {
            const tempObj = {
              quantity: variation.quantity,
              productId: product.id,
              variation: variation,
            };
            return orderdetailsObj.push(tempObj);
          });
        } else {
          orderdetailsObj = [
            {
              quantity: qty,
              productId: product.id,
            },
          ];
        }

        const addtocartObj = {
          orderstatus: 1,
          totalamount: !product.bundlepurchase
            ? this.renderBundlePrice(product.productvariation)
            : product.price * qty,
          inshoppingcart: 1,
          userId: userId,
          orderdetails: orderdetailsObj,
          cityId: cityId,
          date: new Date(),
          // pincode: pincode
        };

        const addToCartResponse = await postCall(addtocartUrl, addtocartObj);
        console.log("addToCartResponse:", addToCartResponse);
        if (addToCartResponse.error) {
          clearLocalStorageReload({ response: addToCartResponse });
          this.loadErrorMessageAnimation(addToCartResponse.error.message);
          if (addToCartResponse.error.statusCode === 401) {
            removeUserDetailAndOtherDetails();
            navigateTo(this.props, `/login`);
            return;
          }
        } else if (
          addToCartResponse.message &&
          (
            addToCartResponse.message === "Sorry! Product is out of stock" ||
            addToCartResponse.message === "Sorry! Product is not availble as per given quantity"
          )
        ) {
          // Show as error modal
          this.loadErrorMessageAnimation(
            getValueFromLanguageObject("str_product_out_of_stock") ||
            addToCartResponse.message ||
            "Sorry! Product is out of stock"
          );
          return;
        } else {
          if (isInquiry) {
            this.loadAddToCartMessageAnimation(
              getValueFromLanguageObject("str_add_to_inquiry_successfully")
                ? getValueFromLanguageObject("str_add_to_inquiry_successfully")
                : "Product inquiry added successfully"
            );
          } else {
            this.loadAddToCartMessageAnimation(
              getValueFromLanguageObject("str_add_to_cart_successfully")
                ? getValueFromLanguageObject("str_add_to_cart_successfully")
                : "Product added to cart successfully."
            );
          }
        }

        // this.props.counter();
        return addToCartResponse;
      } else if (
        product.productvariation &&
        product.productvariation !== null &&
        product.productvariation !== "[]" &&
        product.bundlepurchase
      ) {
        const productVariationParse = JSON.parse(product.productvariation);
        productVariationParse.map((variation) => {
          if (
            JSON.stringify(variation.variation) ===
            JSON.stringify(selectedVariation)
          ) {
            const tempObj = {
              quantity: qty,
              productId: product.id,
              variation: variation,
            };
            return orderdetailsObj.push(tempObj);
          }
        });
      } else {
        orderdetailsObj = [
          {
            quantity: qty,
            productId: product.id,
          },
        ];
      }

      const addtocartObj = {
        orderstatus: 1,
        totalamount: productPrice ? productPrice * qty : product.price * qty,
        inshoppingcart: 1,
        userId: userId,
        orderdetails: orderdetailsObj,
        cityId: cityId,
        date: new Date(),
        // pincode: pincode
      };

      const addToCartResponse = await postCall(addtocartUrl, addtocartObj);
      if (addToCartResponse.error) {
        clearLocalStorageReload({ response: addToCartResponse });
        this.loadErrorMessageAnimation(addToCartResponse.error.message);
        if (addToCartResponse.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        if (isInquiry) {
          this.loadAddToCartMessageAnimation(
            getValueFromLanguageObject("str_add_to_inquiry_successfully")
              ? getValueFromLanguageObject("str_add_to_inquiry_successfully")
              : "Product inquiry added successfully"
          );
        } else {
          this.loadAddToCartMessageAnimation(
            getValueFromLanguageObject("str_add_to_cart_successfully")
              ? getValueFromLanguageObject("str_add_to_cart_successfully")
              : "Product added to cart successfully."
          );
        }
      }

      // this.props.counter();
      return addToCartResponse;
    } catch (error) {
      console.error("Error in addToCart:", error);
      this.loadErrorMessageAnimation("An error occurred while adding to cart");
    }
  };

  getCartListCounter = async () => {
    let cartCounter = 0;
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;
    const counterUrl = "commoncounters?filter[where][userId]=" + userId;
    const commonCounter = await getCall(counterUrl, []).then();
    if (commonCounter.error) {
      clearLocalStorageReload({ response: commonCounter });
      this.loadErrorMessageAnimation(commonCounter.error.message);
    } else {
      if (commonCounter.length > 0) {
        cartCounter = commonCounter[0].cart;
      }
    }
    return cartCounter;
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  loadAddToCartMessageAnimation = (message) => {
    this.setState({
      addToCartMessage: message,
      showAddToCartMessageModal: true,
    });
  };

  loadAddToWishListMessageAnimation = (message) => {
    this.setState({
      addToWishListMessage: message,
      showAddToWishListMessageModal: true,
    });
  };

  loadAddToCompareMessageAnimation = (message) => {
    this.setState({
      addToCompareMessage: message,
      showAddToCompareMessageModal: true,
    });
  };

  render() {
    const { symbol, item, isInquiry } = this.props;

    const {
      stock,
      category,
      shareUrl,
      sharingOptionSettings,
      productPrice,
      product,
      selectedVariation,
      currentCatelogueType,
      isPincodeDeliveryEnable,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
      showAddToCartMessageModal,
      addToCartMessage,
      isShowLastModifiedDate,
      showAddToWishListMessageModal,
      addToWishListMessage,
      showAddToCompareMessageModal,
      addToCompareMessage,
    } = this.state;

    const strlastModifiedOn = getValueFromLanguageObject("str_last_modified_on")
      ? getValueFromLanguageObject("str_last_modified_on")
      : "Last modified on";

    const strThereAre = getValueFromLanguageObject("str_there_are")
      ? getValueFromLanguageObject("str_there_are")
      : "There are";

    const strUnitsOfItemAlreadyInTheCart = getValueFromLanguageObject(
      "str_units_of_item_already_in_the_cart"
    )
      ? getValueFromLanguageObject("str_units_of_item_already_in_the_cart")
      : "units of item already in the cart";

    const strMinimumOrderQuantity = getValueFromLanguageObject(
      "str_minimum_order_quantity"
    )
      ? getValueFromLanguageObject("str_minimum_order_quantity")
      : "Minimum Order Quantity";

    const strAddToWishlist =
      getValueFromLanguageObject("str_add_to_wishlist") || "Add To Wishlist";

    const { isInactive } = this.props;

    return (
      <>
        <div className="col-lg-6 rtl-text">
          <div className="product-right">
            <h2> {item.name} </h2>
            {item.description && (
              <>
                <style>{`
                  /* ensure images still centered */
                  .product-description-html img {
                    display: block;
                    margin: 0 auto;
                    max-width: 100%;
                    height: auto;
                  }
                  /* force normal wrapping and allow list styles inside the injected HTML */
                  .product-description-html {
                    white-space: normal !important;
                    display: block !important;
                  }
                  .product-description-html ul,
                  .product-description-html ol {
                    display: block !important;
                    margin: 0.5rem 0 0.5rem 1.25rem !important;
                    padding-left: 1.25rem !important;
                    list-style-position: outside !important;
                  }
                  .product-description-html li {
                    display: list-item !important;
                    margin-bottom: 0.5rem;
                  }
                `}</style>
                <div
                  className="product-description-html"
                  style={{ ...productDesc, textAlign: "center" }}
                  dangerouslySetInnerHTML={{
                    __html: this.decodeHtmlEntities(item.description),
                  }}
                />
              </>
            )}
            {item &&
              item.productvariation &&
              item.productvariation.length > 0 &&
              currentCatelogueType &&
              currentCatelogueType.registerallow === "Catalogue_FABRIC" && (
                <div className="border-product">
                  {this.renderPriceVarientPanam(product.productvariation)}
                </div>
              )}
            {isInquiry ? (
              <div />
            ) : (
              <div className="mb-2">
                <h3 className="mb-0">{formatPrice(productPrice)}</h3>
                {isShowLastModifiedDate && (
                  <p className="h6 text-muted">
                    {`${strlastModifiedOn} `}
                    <Moment format="DD-MMM-YYYY">
                      {item.lastModifiedPriceDate}
                    </Moment>
                  </p>
                )}
              </div>
            )}

            {item &&
              item.productvariation &&
              item.productvariation.length > 0 &&
              currentCatelogueType &&
              currentCatelogueType.registerallow === "Catalogue_FABRIC" && (
                <div className="border-product">
                  {this.renderPriceVarientPanam(product.productvariation)}
                </div>
              )}

            {item &&
              item.productvariation &&
              item.productvariation.length > 0 &&
              currentCatelogueType &&
              currentCatelogueType.registerallow !== "Catalogue_FABRIC" &&
              this.renderPriceVarientKey(product.productvariation)}

            <div className="product-description border-product">
              {!isInquiry && (
                <span className="instock-cls">
                  {isInactive
                    ? (
                      <span className="text-danger">
                        {getValueFromLanguageObject("str_product_inactive") ||
                          "Product is inactive. Please remove it to proceed."}
                      </span>
                    )
                    : stock
                  }
                </span>
              )}
              {currentCatelogueType &&
                currentCatelogueType.registerallow !== "Catalogue_FABRIC" && (
                  <h6 className="product-title">
                    {getValueFromLanguageObject("str_quantity")
                      ? getValueFromLanguageObject("str_quantity")
                      : "quantity"}
                  </h6>
                )}

              {currentCatelogueType &&
                currentCatelogueType.registerallow !== "Catalogue_FABRIC" && (
                  <div className="qty-box">
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <button
                          type="button"
                          className="btn quantity-left-minus"
                          onClick={this.minusQty}
                          data-type="minus"
                          data-field=""
                        >
                          <i className="fa fa-angle-left" />
                        </button>
                      </span>
                      <input
                        type="number"
                        name="quantity"
                        value={this.state.quantity}
                        onChange={this.changeQty}
                        className="form-control input-number"
                        min={1}
                        max={item.availablequantity} // Prevent entering more than availablequantity
                      />
                      <span className="input-group-prepend">
                        <button
                          type="button"
                          className="btn quantity-right-plus"
                          onClick={this.plusQty}
                          data-type="plus"
                          data-field=""
                        >
                          <i className="fa fa-angle-right" />
                        </button>
                      </span>
                    </div>
                  </div>
                )}

              {item &&
                item.minimumorderquantity &&
                item.minimumorderquantity > 1 && (
                  <div className="product-description mt-1 text-danger">
                    {`${strMinimumOrderQuantity}: ${item.minimumorderquantity}`}
                  </div>
                )}

              {item && item.totalCartCounter > 0 && (
                <div className="product-description mt-3">
                  {`${strThereAre} ${product.totalCartCounter} ${strUnitsOfItemAlreadyInTheCart}`}
                </div>
              )}
            </div>

            <div className="product-buttons">
              {currentCatelogueType &&
                currentCatelogueType.registerallow === "Catalogue_FABRIC" && (
                  <div>
                    <h6 className="product-title">
                      {getValueFromLanguageObject("str_bundle_price")
                        ? getValueFromLanguageObject("str_bundle_price")
                        : "Bundle Price :"}{" "}
                      {symbol}
                      {this.renderBundlePrice(product.productvariation)}
                    </h6>
                    <br />
                  </div>
                )}

              <button
                className="btn btn-solid mb-2 mb-md-0"
                onClick={async () => {
                  this.addToCartBase();
                }}
                disabled={
                  isInactive ||
                  (!isInquiry && product && product.availablequantity === 0)
                    ? true
                    : false
                }
              >
                {isInquiry
                  ? getValueFromLanguageObject("str_add_to_inquiry") ||
                    "Add To Inquiry"
                  : getValueFromLanguageObject("str_add_to_cart") ||
                    "Add To Cart"}
              </button>

              <button
                className="btn btn-solid mr-1 ml-1 mb-2 mb-md-0"
                style={{background:'#1252C9'}}
                onClick={async () => {
                  this.onAddToWishlistClicked();
                }}
              >
                {strAddToWishlist}
              </button>

              <button
                className="btn btn-solid mr-1 ml-1 mb-2 mb-md-0"
                onClick={() => {
                  this.onAddToCompareClicked();
                }}
                style={{background:'#1252C9'}}
              >
                {getValueFromLanguageObject("str_add_to_compare")
                  ? getValueFromLanguageObject("str_add_to_compare")
                  : "Add to Compare"}
              </button>

              {currentCatelogueType &&
                currentCatelogueType.registerallow === "Catalogue_FABRIC" && (
                  <div
                    className="btn btn-solid"
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      this.onClickOfSampleReuest(item);
                    }}
                  >
                    {" "}
                    {getValueFromLanguageObject("str_sample_request")
                      ? getValueFromLanguageObject("str_sample_request")
                      : "Sample Request"}
                  </div>
                )}
            </div>

            {category.name && (
              <div className="border-product">
                <div>
                  <h6 className="product-title">
                    {getValueFromLanguageObject("str_products_category")
                      ? getValueFromLanguageObject("str_products_category")
                      : "Product's Category"}
                  </h6>
                  <p>{category.name}</p>
                </div>
              </div>
            )}
            <div className="border-product">
              <h6 className="product-title">
                {getValueFromLanguageObject("str_products_sub_category")
                  ? getValueFromLanguageObject("str_products_sub_category")
                  : "Product's Sub-Category"}
              </h6>
              <p>
                {item &&
                item.category !== undefined &&
                item.category.name !== undefined
                  ? item.category.name
                  : ""}
              </p>
            </div>
            {sharingOptionSettings &&
              sharingOptionSettings.status === 1 &&
              shareUrl !== "" && (
                <div className="border-product">
                  <h6 className="product-title">
                    {getValueFromLanguageObject("str_share_this_to")
                      ? getValueFromLanguageObject("str_share_this_to")
                      : "Share This To"}
                  </h6>
                  <div className="product-icon">
                    <ul className="product-social">
                      <li>
                        <FacebookShareButton
                          url={shareUrl}
                          quote={this.getProductQuote(item)}
                          hashtag={`#${client ? client : publicUrl}`}
                        >
                          <FacebookIcon size={42} round />
                        </FacebookShareButton>
                      </li>

                      <li>
                        <TwitterShareButton
                          url={shareUrl}
                          via={this.getProductQuoteTwitter(item)}
                          hashtags={[`${client ? client : publicUrl}`]}
                        >
                          <TwitterIcon size={42} round />
                        </TwitterShareButton>
                      </li>

                      <li>
                        <TelegramShareButton
                          url={shareUrl}
                          title={this.getProductQuoteTwitter(item)}
                        >
                          <TelegramIcon size={42} round />
                        </TelegramShareButton>
                      </li>

                      <li>
                        <WhatsappShareButton
                          url={shareUrl}
                          title={this.getProductQuoteTwitter(item)}
                          separator=" :: "
                        >
                          <WhatsappIcon size={42} round />
                        </WhatsappShareButton>
                      </li>

                      <li>
                        <LinkedinShareButton
                          url={shareUrl}
                          source={client ? client : publicUrl}
                          summary={this.getProductQuoteTwitter(item)}
                        >
                          <LinkedinIcon size={42} round />
                        </LinkedinShareButton>
                      </li>

                      <li>
                        <EmailShareButton
                          url={shareUrl}
                          subject={"Product Details"}
                          body={this.getProductQuoteTwitter(item)}
                        >
                          <EmailIcon size={42} round />
                        </EmailShareButton>
                      </li>
                    </ul>
                  </div>
                  <div style={{ display: "flex", marginTop: "5px" }}>
                    <input
                      type="text"
                      disabled
                      name="shareInput"
                      value={shareUrl}
                      className="form-control"
                    />

                    <CopyToClipboard
                      text={shareUrl}
                      onCopy={() => {
                        this.loadSuccessMessageAnimation(
                          getValueFromLanguageObject(
                            "str_product_link_copied_to_clipboard"
                          )
                            ? getValueFromLanguageObject(
                                "str_product_link_copied_to_clipboard"
                              )
                            : "Product link copied to clipboard"
                        );
                      }}
                    >
                      <div className="btn btn-solid">
                        {getValueFromLanguageObject("str_copy")
                          ? getValueFromLanguageObject("str_copy")
                          : "Copy"}
                      </div>
                    </CopyToClipboard>
                  </div>
                </div>
              )}
          </div>
        </div>
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}
        {showAddToCartMessageModal && (
          <AddToCartAnim
            show={showAddToCartMessageModal}
            message={addToCartMessage}
            onClose={() => {
              this.setState({ showAddToCartMessageModal: false });
            }}
          />
        )}
        {showAddToWishListMessageModal && (
          <AddToWishListAnim
            show={showAddToWishListMessageModal}
            message={addToWishListMessage}
            onClose={() => {
              this.setState({ showAddToWishListMessageModal: false });
            }}
          />
        )}
        {showAddToCompareMessageModal && (
          <SuccessMessageAnimationModal
            show={showAddToCompareMessageModal}
            message={addToCompareMessage}
            onClose={() => {
              this.setState({ showAddToCompareMessageModal: false });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    symbol: getCurrencySymbol(),
    isInquiry: state.settings.isInquiry,
    wishlist: state.settings.wishlist,
  };
};

export default connect(mapStateToProps, {
  counter: getCommonCounter,
  isInquiryOrCart: isInquiryOrCart,
  updateQuantity: getUpdateQuantity,
  getWishlist: getWishlist,
  addToCompare: addToCompare,
  setHeaderCounters,
})(withRouter(DetailsWithPrice));
